import { ToastContainer, toast } from 'react-toastify';

import loading from "../../../assets/images/loading.gif"
import { useState, useEffect } from "react";
import { makeGetRequest, makePatchRequest } from "../../../request";
import { useDispatch, useSelector } from "react-redux";
import { customStyles, formatDateTime, } from "../../../helpers";
import Pagination from "../../../components/Pagination";
import Layout from '../../Layout';
import Modal from "react-modal"
import { useLocation, useNavigate } from 'react-router-dom';
import { setPageContext } from 'store/pageContext';
import { SelectedShippingDocuments } from 'interfaces/index.types';

const BatchAssignShippingDocuments =  () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const location = useLocation()
    const user = useSelector((state: any) => state.tepngUser.value);
    const statusBeforeNavigation = location.state as { status: boolean, currentPage: number };
    // const queryParams = new URLSearchParams(window.location.search)
    const [shippingDocuments, setRecords] = useState<Record <string, any>>([]) 
    const [selectedDocuments, setSelectedDocuments] = useState<SelectedShippingDocuments[]>([])
    const [reassignLocalClearingAgentModal, setReassignLocalClearingAgentModal] = useState(false)
    

    const [currentPage, setCurrentPage] = useState(statusBeforeNavigation?.currentPage ? statusBeforeNavigation?.currentPage : 1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [totalItems, setTotalItems] = useState(0);
    const totalPages = Math.ceil(totalItems / itemsPerPage);

    const [startIndex, setStartIndex] = useState(0);
    const getPageNumbers = () => {
        return Array.from({ length: totalPages }, (_, i) => i + 1);
    };

    const handleNext = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
            if (currentPage >= startIndex + 4) {
                setStartIndex(startIndex + 4);
            }
        }
    };

    const handlePrevious = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
            if (currentPage - 1 <= startIndex) {
                setStartIndex(startIndex - 4);
            }
        }
    };
    
    const [searchValue, setSearchValue] = useState("")
    const handleSearch = (event: any) => {
        const value = event.target.value
        if(!value) {setSearchValue(""); setStatus(false)}
    }

    const handleChange = (event: any) => {        
        const { name, value } = event.target //get data form each input on change

        setFormData(values => ({...formData, [name]: value})) //set retrieved values to "formData" object 

        if(name === "receiver") getShippingChatHistory(value)
    }
    
    const [formData, setFormData] = useState({
        documentName: "",
        document: "",
        shippingDocumentId: "", 
        freightForwarderId: "", 
        localClearingAgentId: "",
        portOfficerStatus: "",
        receiver: "",
        comment: "",
        attachments: [],
        transitManagerId: "",
        reasonForReassignment: "",
        rowVersion: ""
    })

    const clearData = () => {
        setFormData({
            documentName: "",
            document: "",
            shippingDocumentId: "",
            freightForwarderId: "", 
            localClearingAgentId: "",
            portOfficerStatus: "",
            receiver: "",
            comment: "",
            attachments: [],
            transitManagerId: "",
            reasonForReassignment: "",
            rowVersion: ""
        })
    }

    const clearFormData = () => {
        setFormData({...formData, localClearingAgentId: "", transitManagerId: "", shippingDocumentId: "", reasonForReassignment: "", rowVersion: ""})
    }

    const [isLoading, setIsLoading] = useState(false)
    const [isChatLoading, setIsChatLoading] = useState(false)
    const [isSubmitting, setIsSubmitting] = useState(false)
    const [status, setStatus] = useState<boolean | null>(statusBeforeNavigation?.status ? statusBeforeNavigation?.status : false)
    const [openChatHistory, setOpenChatHistory] = useState(false)
    const [filterLocalClearingAgentValue, setFilterLocalClearingAgentValue] = useState("")

    const getShippingDocuments = () => {
        setIsLoading(true)
        var request: Record<string, any> = {
            what: !filterLocalClearingAgentValue ? "getShippingDocumentsForBatching" : "getShippingDocumentsForLocalClearingAgent",
            params: {
                Page: currentPage,
                PageSize: itemsPerPage,
                OrderBy: 2,
                // ...(!filterLocalClearingAgentValue && {assigned: status === null ? false : status}),
                ...(!filterLocalClearingAgentValue && {assigned: status}),
                ...(filterLocalClearingAgentValue && {localClearingAgentId: filterLocalClearingAgentValue})
            }
        };
        if(searchValue) request.params.SearchString = searchValue; 
        
        makeGetRequest(request)
            .then((response: any) => {
                setIsLoading(false)
                const res = response.data.data
                setRecords(res)
                setTotalItems(response.data.totalCount)
            })
            .catch((error:any) => 
                !filterLocalClearingAgentValue ? toast.error(error.msg) : null
            );
    }
    const [chats, setChats] = useState<Record <string, any>>([])
    const getShippingChatHistory = (selectedReceiver: string) => {
        setIsChatLoading(true)
        var request: Record<string, any> = {
            what: "getShippingDocumentChatHistory",
            params: {
                shippingDocumentId: formData.shippingDocumentId,
                sender: "TransitOfficer",
                receiver: selectedReceiver === "Freight Forwarder" ? formData.freightForwarderId :
                            selectedReceiver === "Local Clearing Agent" ? formData.localClearingAgentId : ""
            }
        };
        
        makeGetRequest(request)
            .then((response: any) => {
                setIsChatLoading(false)
                const res = response.data.data
                setChats(res.sort((a: any, b: any) => new Date(b.createdDate).getTime() - new Date(a.createdDate).getTime()))
            })
            .catch((error:any) => 
                {toast.error(error.msg); setIsChatLoading(false)}
            );
    }

    const handleCheck = (e:React.ChangeEvent<HTMLInputElement>) => {
        const { value, checked } = e.target
        if(checked){
            const item: any = shippingDocuments?.find((item:any) => item.id === value)
            const selectedItem: any = {
                id: item?.id,
                shipmentNumber: item?.shippingNumber,
                referenceNumber: item?.referenceNumber,
                createdDate: item?.createdDate,
                modeOfShipping: item?.consolidatedPackingList.modeOfShipping,
                destination: item?.consolidatedPackingList.destination,
                rowVersion: item?.rowVersion
            }
            setSelectedDocuments([...selectedDocuments, selectedItem])
        }else {
            var remainingItems = selectedDocuments.filter((item:any) => item.id !== value)
            setSelectedDocuments(remainingItems)
        }
    }

    const handleCheckAll = (e:React.ChangeEvent<HTMLInputElement>) => {
        const { checked } = e.target
        if(checked){
            const items:any = shippingDocuments?.map((item:any) => ({                
                id: item?.id,
                shipmentNumber: item?.shippingNumber,
                referenceNumber: item?.referenceNumber,
                createdDate: item?.createdDate,
                modeOfShipping: item?.consolidatedPackingList.modeOfShipping,
                destination: item?.consolidatedPackingList.destination
                }));

            setSelectedDocuments(items);
            
        }else setSelectedDocuments([])
    }

    const row = shippingDocuments?.map((data: any, index:number) => {
                    return (
                        <tr key={index}>
                            {!status && <td>
                                <input type="checkbox" 
                                value={data.id} 
                                onChange={handleCheck} 
                                checked={!!selectedDocuments.find(item => item.id === data.id)}/>
                            </td>}
                            {status && <td>{ currentPage === 1 ? currentPage + index : (((itemsPerPage*currentPage)-itemsPerPage)+1) + index }</td>}
                            <td>{ data.referenceNumber ?? "N/A" }</td>
                            <td>{ data.shippingNumber }</td>
                            <td>{ data.consolidatedCommercialInvoice?.modeOfShipping }</td>
                            <td>{ data?.consolidatedCommercialInvoice?.purchaseOrderItemSupplies[0]?.currency }</td>
                            <td>{ data?.consolidatedCommercialInvoice?.consignee }</td>
                            <td>{ data?.consolidatedCommercialInvoice?.destinationPlant }</td>
                            {status && <td>{ data?.localClearingAgent?.companyName }</td>}
                            <td>
                                <div className="dropdown">
                                    <button className="dropbtn-2"><span className="material-symbols-outlined" style={{fontSize: "24px"}}>more_horiz</span></button>
                                    <div className="dropdown-content">
                                        <button onClick={() => {
                                                navigate("/transitmanager/shippingdocuments/"+data.id, {state: {status: status, currentPage: currentPage}}); 
                                                dispatch(setPageContext({page: "Local Clearing Agents", 
                                                url: `/transitmanager/batch-assign-shipping-documents`, }))                                                
                                            }}
                                        >View Documents</button>

                                        {data?.localClearingAgent && <button
                                            onClick={() => {setReassignLocalClearingAgentModal(true); setFormData({...formData, shippingDocumentId: data?.id, transitManagerId: user?.id}); GetAllUsersForAThirdPartyRole()}}
                                            >Reassign</button>}

                                        <button 
                                            onClick={() => {setOpenChatHistory(true); 
                                            setFormData({...formData, shippingDocumentId: data.id, freightForwarderId: data.freightForwarderId, localClearingAgentId: data.localClearingAgentId, attachments: data.shippingDocumentAttachments, portOfficerStatus: data.portOfficerStatus})}}>
                                            View Chats
                                        </button>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    )
                })

    const [localClearingAgentModal, setLocalClearingAgentModal] = useState(false)
    const [isLoading2, setIsLoading2] = useState(false)
    const [users, setUsers] = useState<Record <string, any>>()
    const GetAllUsersForAThirdPartyRole = () => {
        setIsLoading2(true)
        var request: Record<string, any> = {
            what: "GetAllUsersForAThirdPartyRole",
            params: {
                page: 1,
                pageSize: 100,
                roleName: "LocalClearingAgent"
            }
        };
        
        makeGetRequest(request)
            .then((response: any) => {
                setIsLoading2(false)
                const res = response.data.data
                setUsers(res)
            })
            .catch((error:any) => 
                toast.error(error.errorMessage)
            );

           
    } 

    const handleRadioChange = (event: any) => {
        const {checked, value} = event.target
        if(checked) setFormData({...formData, localClearingAgentId: value})
        else setFormData({...formData, localClearingAgentId: ""})
    }
    const row2 = users?.map((user: any, index: number) => {
        return (
                <tr key={index}>
                    <td>
                        <input
                            type='radio' 
                            value={user?.user.id}
                            checked={formData.localClearingAgentId === user?.user.id}
                            onChange={handleRadioChange} />
                    </td>
                    <td>{ user?.user.companyName }</td>
                    <td>{ user?.user.email }</td>                    
                </tr>
        )
    })

    const HandleBatchAssignShippingDocuments = () => {
        const selectedShippingDocumentsDetails = selectedDocuments.map((data: any) => ({
            shippingDocumentId: data.id,
            rowVersion: data.rowVersion
        }))
        var request: Record<string, any> = {
            what: "BatchAssignShippingDocumentsToLocalClearingAgent",
            data: {
                LocalClearingAgentId: formData.localClearingAgentId,
                TransitManagerId: user?.id,
                ShippingDocumentRowVersions: selectedShippingDocumentsDetails
            }
        };
        
        if(!formData.localClearingAgentId) toast.warning("A local clearing agent is required!")
        else {
            setIsSubmitting(true)
            makePatchRequest(request)
                .then((response: any) => {
                    setIsSubmitting(false)
                    toast.success(response.msg)
                    getShippingDocuments()
                    setLocalClearingAgentModal(false)
                    setFormData({...formData, localClearingAgentId: ""})
                    setSelectedDocuments([])
                })
                .catch((error:any) => {toast.error(error.msg); setIsSubmitting(false)});
        }
    }

    const HandleRessignShippingDocument = () => {
        
        var request: Record<string, any> = {
            what: "HandleRessignShippingDocument",
            data: {
                localClearingAgentId: formData.localClearingAgentId,
                transitManagerId: formData.transitManagerId,
                shippingDocumentId: formData.shippingDocumentId,
                reasonForReassignment: formData.reasonForReassignment,
            }
        };
        if(Object.values(request.data).every(value => value)) {
            setIsSubmitting(true)
            makePatchRequest(request)
                .then((response: any) => {
                    setIsSubmitting(false)
                    toast.success(response.msg)
                    setReassignLocalClearingAgentModal(false) // close modal
                    clearFormData()
                    getShippingDocuments()
                })
                .catch((error:any) => {toast.error(error.errorMessage); setIsSubmitting(false)});
        }else {
            toast.warning("Kindly provide information for all required fields!")
        }
    }

    useEffect(() => {
        if(filterLocalClearingAgentValue) setStatus(null)
        
    }, [filterLocalClearingAgentValue])
    
    useEffect(() => {
        getShippingDocuments()
        GetAllUsersForAThirdPartyRole()
        // eslint-disable-next-line
    }, [currentPage, itemsPerPage, searchValue, status, filterLocalClearingAgentValue])

    const page = "Local Clearing Agent Assignment"

    return (
        <Layout title={page}>
            <div className="container">
                <div className="main">
                    <h3 className="page_title">{  }</h3>     
                    <div className="main-inner">
                        <div className="main-inner-top">
                            <div className="d-flex">
                                <div className="search-container left-item">
                                    <span className="material-symbols-rounded">search</span>
                                    <input id="search" placeholder="Search Shipping Number" onKeyUp={handleSearch}  />
                                </div>
                                <button className="custom-button orange left-item ml-2"
                                    onClick={() => {setSearchValue((document.getElementById("search") as HTMLInputElement)?.value); setCurrentPage(1)}}
                                >Search</button>
                            </div>
                            
                            {selectedDocuments.length > 0 &&
                                <button className="custom-button orange right-item mr-2" onClick={() => setLocalClearingAgentModal(true)}>Assign</button> }
                            
                            <select value={filterLocalClearingAgentValue} className='right-item mr-2' onChange={(e) => {setFilterLocalClearingAgentValue(e.target.value); }} >
                                <option key="0" value="" disabled>All Local Clearing Agents</option>
                                {
                                    users?.map((localclearingagent: any) => {
                                        return (
                                            <option key={localclearingagent.user.id} value={localclearingagent.user.id}>{localclearingagent.user.companyName}</option>
                                        )
                                    })
                                }                            
                            </select>
                           
                            <div className='d-flex' style={{gap: "16px"}}>
                                <div className="d-flex page-filter">
                                    <span style={{fontSize: "12px", color: "#3e3e3e", fontWeight:"500"}}> Filter By </span>
                                    <div className={status === false ? "orange active": "orange"} onClick={() => {setStatus(false); setCurrentPage(1); setFilterLocalClearingAgentValue("")}}>
                                    {status === false && <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="#175FDC" style={{width: "10px", marginRight: "4px"}}><path d="M173.9 439.4l-166.4-166.4c-10-10-10-26.2 0-36.2l36.2-36.2c10-10 26.2-10 36.2 0L192 312.7 432.1 72.6c10-10 26.2-10 36.2 0l36.2 36.2c10 10 10 26.2 0 36.2l-294.4 294.4c-10 10-26.2 10-36.2 0z"/></svg>}
                                        Unassigned</div>

                                    <div className={status === true ? "green active": "green"} onClick={() => {setStatus(true); setCurrentPage(1); setFilterLocalClearingAgentValue("")}}>
                                    {status === true && <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="#175FDC" style={{width: "10px", marginRight: "4px"}}><path d="M173.9 439.4l-166.4-166.4c-10-10-10-26.2 0-36.2l36.2-36.2c10-10 26.2-10 36.2 0L192 312.7 432.1 72.6c10-10 26.2-10 36.2 0l36.2 36.2c10 10 10 26.2 0 36.2l-294.4 294.4c-10 10-26.2 10-36.2 0z"/></svg>}
                                        Assigned</div>
                                </div>
                            </div>
                        </div>                        

                        <div className='table-container custom'>
                            <table>
                                <thead>
                                    <tr className="no-textwrap">
                                        {!status && <th><input type="checkbox" onChange={handleCheckAll} /></th>}
                                        {status && <th>SN</th>}
                                        <th>BL/AWB Number</th>
                                        <th>Shipment Number</th>
                                        <th>Shipping Mode</th>
                                        <th>Currency</th>
                                        <th>Consignee</th>
                                        <th>Destination Plant</th>
                                        {status && <th>Local Clearing Agent</th>}
                                        <th style={{width: "116px"}}>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {isLoading ? null : (
                                            shippingDocuments?.length === 0 ? <td className='no-records' colSpan={6}>No Records Found</td>
                                            : row
                                        )
                                    }
                                </tbody>
                            </table>
                            {isLoading ? <div className="loader">
                                        <img src={loading} alt="loading" />
                                        <p>Loading data...</p>
                                    </div> : null}
                        </div>
                        <div className="pagination-container">
                            <Pagination
                                currentPage={currentPage}
                                itemsPerPage={itemsPerPage}
                                totalPages={totalPages}
                                handlePrevious={handlePrevious}
                                handleNext={handleNext}
                                setCurrentPage={setCurrentPage}
                                getPageNumbers={getPageNumbers}
                                setItemsPerPage={setItemsPerPage}
                                startIndex={startIndex} />
                        </div>
                    </div>                 
                </div>     
                <Modal isOpen={openChatHistory} style={customStyles} className="modal modal-7" ariaHideApp={false}>
                    <div className="modal-header">
                        <h3>Chats</h3>
                        <span className="material-symbols-rounded close"
                            onClick={() => {setOpenChatHistory(false); setIsSubmitting(false); clearData()} }>close</span>
                    </div>
                    <div className="modal-body" style={{ minHeight: "300px"}}>
                        <label><span className='errorX mr-2'>*</span>Entity</label>
                        <select value={formData.receiver} onChange={handleChange} name='receiver' required>
                            <option value="" disabled>--Select--</option>
                            <option value="Freight Forwarder">Freight Forwarder</option>
                            <option value="Local Clearing Agent">Local Clearing Agent</option>
                        </select>

                        {!formData.receiver && <p>No source selected yet.</p>}
                        {(!isChatLoading && formData.receiver && !chats.length) && <p>No Chats Found.</p>}

                        {!isChatLoading && formData.receiver && 
                        <div className='chat-container mt-1' style={{maxHeight: "250px"}}>
                            {chats.map((chat: any, index: number) => {
                                return (
                                    <div key={index} className={`chat-dialog ${chat.sender === "TransitOfficer" ? "right" : "left"}`}>
                                        <label className='title'>{chat.sender === "TransitOfficer" ? "Transit Team" : formData.receiver}</label>
                                        <p>{chat.message}</p>
                                        <span className='date'>{formatDateTime(chat.createdDate)}</span>
                                    </div>
                                )
                            })}
                        </div>}

                        {isChatLoading && 
                        <div className="loader">
                            <img src={loading} alt="loading" />
                            <p className="d-flex-center">Loading Chats...</p>
                        </div>}
                    </div>
                </Modal>

                <Modal isOpen={localClearingAgentModal} style={customStyles} className="modal modal-8" ariaHideApp={false}>
                    <div className="modal-header">
                        <h3>Assign Shipping Documents</h3>
                        <span className="material-symbols-rounded close"
                            onClick={() => {setLocalClearingAgentModal(false); setFormData({...formData, localClearingAgentId: ""})}}>close</span>
                    </div>
                    <label><span className="errorX mr-2">*</span>Select Local Clearing Agent</label>
                    <div className="table-container custom modal-body mt-1" style={{minHeight: "200px", maxHeight: "300px", overflowY: "auto"}}>
                        <table>
                            <thead>
                                <tr className="no-textwrap">
                                    <th></th>
                                    <th>Company</th> 
                                    <th>Official Email</th>                                         
                                </tr>
                            </thead>
                            <tbody>
                                {isLoading2 ? null : (
                                            users?.length === 0 ? <td className='no-records' colSpan={6}>No Records Found</td>
                                            : row2
                                        )
                                    }
                            </tbody>
                        </table>
                    </div>
                    
                    <div className="modal-footer bt-1">
                        <button className="custom-button grey-outline"
                            onClick={() => {setLocalClearingAgentModal(false); setFormData({...formData, localClearingAgentId: ""})}}>Cancel</button>
                        <button disabled={isSubmitting} type="submit" className="custom-button orange"
                            onClick={() => HandleBatchAssignShippingDocuments()}>{isSubmitting ? "Loading..." : "Assign"}</button>
                    </div>
                </Modal> 

                <Modal isOpen={reassignLocalClearingAgentModal} style={customStyles} className="modal modal-8" ariaHideApp={false}>
                    <div className="modal-header">
                        <h3>Reassign Shipping Document</h3>
                        <span className="material-symbols-rounded close"
                            onClick={() => {setReassignLocalClearingAgentModal(false); clearFormData()}}>close</span>
                    </div>
                    <label><span className="errorX mr-2">*</span>Select Local Clearing Agent</label>
                    <div className="table-container custom modal-body mt-1" style={{minHeight: "200px", maxHeight: "300px", overflowY: "auto"}}>
                        <table>
                            <thead>
                                <tr className="no-textwrap">
                                    <th></th>
                                    <th>Company</th> 
                                    <th>Official Email</th>                                         
                                </tr>
                            </thead>
                            <tbody>
                                {isLoading2 ? null : (
                                            users?.length === 0 ? <td className='no-records' colSpan={6}>No Records Found</td>
                                            : row2
                                        )
                                    }
                            </tbody>
                        </table>
                    </div>
                    <label><span className="errorX mr-2">*</span>Reason</label>
                    <textarea
                        className="mt-1" 
                        onChange={(e) => setFormData({...formData, reasonForReassignment: e.target.value})}
                        value={formData?.reasonForReassignment}
                    ></textarea>
                    <small style={{fontSize: "10px"}} className={formData?.reasonForReassignment?.length >= 100 ? "mt-1 error" : "mt-1"}>{formData?.reasonForReassignment?.length}/100 Characters</small> 
    
                    <div className="modal-footer bt-1">
                        <button className="custom-button grey-outline"
                            onClick={() => setReassignLocalClearingAgentModal(false)}>Cancel</button>
                        <button disabled={isSubmitting} type="submit" className="custom-button orange"
                            onClick={() => HandleRessignShippingDocument()}>{isSubmitting ? "Reassigning..." : "Reassign"}</button>
                    </div>
                </Modal>
                <ToastContainer />
            </div>
        </Layout>
    )
}

export default BatchAssignShippingDocuments